module.exports = __webpack_public_path__ + "img/sharedMediaFolders.7a78f719.svg";